module.exports = __webpack_public_path__ + "static/img/g5.430849b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/g5.png
// module id = j39J
// module chunks = 1